import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "../../../../../../enums/reducer";
import { type GenericFiltersMap } from "../../../../../../utils/filterUtils";
import { createFiltersSlice, type FiltersState } from "../../../../../Application/slices/createFiltersSlice";
import { type SurveyFiltersEnum } from "../../../../Surveys/types/models";
import { type PayloadAction } from "@reduxjs/toolkit";
import { type VideoFiltersEnum } from "../../../../Videos/types/models";

export type FlowContentFilters = VideoFiltersEnum | SurveyFiltersEnum;

export interface FlowDesignerFiltersState extends FiltersState<FlowContentFilters> {
  search: string;
}

export const initialState: FlowDesignerFiltersState = {
  filterOptions: {} as GenericFiltersMap<FlowContentFilters>,
  appliedFilter: {} as GenericFiltersMap<FlowContentFilters>,
  isLoading: false,
  search: "",
};

const flowDesignerFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Flows,
    name: "designerFilters",
  },
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
  },
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetFilter,
  setSearch,
} = flowDesignerFiltersSlice.actions;

export default flowDesignerFiltersSlice.reducer;
